import type { HTMLAttributes } from "react";
import { cn } from "@/lib/cn.ts";

type Variant = "default" | "success" | "warning" | "danger" | "info" | "muted";

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> { variant?: Variant; }

const VARIANTS: Record<Variant, string> = {
  default: "bg-surface-100 text-surface-700 border-surface-200",
  success: "bg-emerald-50 text-emerald-700 border-emerald-200",
  warning: "bg-amber-50 text-amber-700 border-amber-200",
  danger:  "bg-red-50 text-red-700 border-red-200",
  info:    "bg-brand-100 text-brand-700 border-brand-200",
  muted:   "bg-surface-50 text-surface-500 border-surface-200",
};

export function Badge({ variant = "default", className, ...props }: BadgeProps) {
  return (
    <span
      className={cn("inline-flex items-center rounded-full border px-2 py-0.5 text-[11px] font-medium", VARIANTS[variant], className)}
      {...props}
    />
  );
}
